if (!customElements.get('product-personalization')) {
  customElements.define(
    'product-personalization',
    class ProductPersonalization extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-personalization-input]').forEach((input) => {
          const counter = input.parentElement.querySelector('[data-personalization-counter]');
          this.updateCounter(input, counter);
          input.addEventListener('input', () => this.updateCounter(input, counter));
        });
      }

      updateCounter(input, counter) {
        if (!counter) return;
        const max = Number(input.getAttribute('maxlength'));
        counter.textContent = `${input.value.length}/${max}`;
        counter.classList.toggle('personalization-field__counter--limit', input.value.length >= max);
      }
    }
  );
}
